<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Users/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'users'
    }
  },

  created () {
    this.$store.dispatch(`${this.modelName}/getItems`)
  }
}
</script>
